// extracted by mini-css-extract-plugin
export default {"noResultsWrapper":"NoResults_noResultsWrapper__v7Per"};